import styled from "styled-components";
// import styled from 'styled-components/native';

export const Content = styled.div`
  background-color: white;
`;
